// stepTwoValidation.js
import * as Yup from 'yup';
import { isPastDate, isFutureDate } from './validationHelpers';

export const stepTwoSchema = Yup.object().shape({
  marital_status: Yup.string()
    .oneOf(['Married', 'Single'], 'Invalid Marital Status selected'),
  license_no: Yup.string()
    .optional(),
  drivers_license_type: Yup.string()
    .required("Driver's License Type is required")
    .oneOf(
      ['Driving license', 'Temporary Driving License', 'CDL', 'Temporary CDL', 'No Driving License'],
      'Invalid License Type selected'
    ),
  drivers_license_issue_date: Yup.date()
    .required('Issue Date is required')
    .typeError('Issue Date must be a valid date')
    .test('is-past', 'Issue Date must be in the past', isPastDate),
  drivers_license_expire_date: Yup.date()
    .required('Expiration Date is required')
    .typeError('Expiration Date must be a valid date')
    .test('is-future', 'Expiration Date must be in the future', isFutureDate),
  license_state: Yup.string()
    .required('License/ID State is required')
    .matches(/^[A-Z]{2}$/, 'License/ID State should be a two-letter uppercase code'),
  ssn: Yup.string()
    .required('Social Security Number is required')
    .matches(/^\d{3}-\d{2}-\d{4}$/, 'SSN should be 9 digits (e.g., 123-45-6789)'),
  ssn_confirm: Yup.string()
    .required('Confirm Social Security Number is required')
    .oneOf([Yup.ref('ssn')], 'Confirm Social Security Number does not match SSN'),
});